<template>
    <div class="main d-flex flex-column justify-content-center bg-white">
        <section id="brn-locations">
            <GoogleMap
                ref="map"
                @ready="getLocations">
            </GoogleMap>
        </section>
    </div>
</template>

<script>
import GoogleMap from "../components/elements/GoogleMap";
import SettingsMixin from "../../mixins/SettingsMixin";
import ApiRequest from "../../utils/api-request";
export default {
    name: "Locations",
    components: {GoogleMap},
    mixins: [SettingsMixin],
    data() {
        return {
            points: []
        }
    },
    methods: {
        getLocations() {
            new ApiRequest().getLocations().then(
                (response) => {
                    response.data.data.forEach(location => {
                        if (!this.settings.altLocations.includes(location.id)
                            && this.settings.location.id !== location.id) return;

                        location.position = {
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng)
                        };
                        this.$refs.map.addMarker(location)
                    });
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
